import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import Vuetify from "vuetify";
import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { FieldSummary } from "@/modules/FormTemplate/models/FieldSummary";

Vue.use(Vuetify);
@Component({
  name: "FormSummaryPreview"
})
export default class FormSummaryPreview extends Vue {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  @Prop() private model!: any;
  @Prop() private formSummary!: FieldSummary[];
  @Prop() private title?: string;

  formTextSummary = "";

  FORM_SUMMARY_TEXT = this.title ?? FORM_TEMP_CONSTANTS.SUMMARY_LABEL.DATA;

  mounted() {
    this.buildSummary();
  }

  @Watch("formSummary", { deep: true })
  @Watch("model", { deep: true })
  buildSummary() {
    if (this.model) {
      let formTextSummary = "";
      this.formSummary.forEach((fieldSummary: FieldSummary) => {
        if (fieldSummary.summary && fieldSummary.field != undefined) {
          let fieldValue = this.model[fieldSummary.field];
          if (fieldValue == undefined) {
            fieldValue = "";
          }
          formTextSummary = `${formTextSummary}${fieldSummary.summaryText} ${fieldValue}, `;
        }
      });
      formTextSummary = formTextSummary.substring(
        0,
        formTextSummary.length - 2
      );
      formTextSummary = `${formTextSummary}.`;
      this.formTextSummary = formTextSummary;
    }
  }
}
